import Btn from "@/components/common/Btn";
import { IPaymentMethod } from "@/models/user";
import { MDBCol, MDBRow } from "mdb-react-ui-kit";
import styles from "@/styles/common/CreditCard.module.scss";

const CreditCard = ({
    creditCardData,
    onClickDelete,
}: {
    creditCardData: IPaymentMethod;
    onClickDelete?: (id: string) => void;
}) => {
    // eslint-disable-next-line camelcase
    const { id } = creditCardData;
    const {
        brand,
        last4,
        exp_month: expMonth,
        exp_year: expYear,
    } = creditCardData.card;

    const showDelete = onClickDelete && id;

    return (
        <MDBRow>
            {showDelete && (
                <MDBCol size={1} top className="me-2">
                    <Btn
                        className={styles.buttonDelete}
                        onClick={() => onClickDelete(id)}
                    >
                        <i className="fas fa-trash" />
                    </Btn>
                </MDBCol>
            )}
            <MDBCol size={10} xl={8}>
                <p className={styles.cardNumber}>
                    {brand} {last4}
                </p>
                <p className={styles.expirationDate}>
                    Expiration date: {expMonth}/{expYear}
                </p>
            </MDBCol>
        </MDBRow>
    );
};

export default CreditCard;
